import { COLORS } from '../../../../constants';

const styles = theme => {
  const minMd = theme.breakpoints.up('md');

  return {
    root: {
      backgroundColor: 'transparent',
      paddingLeft: 0,
      paddingRight: 0,
    },
    stepLabelNormal: {
      color: COLORS.GREY_DARK,
      fontWeight: 500,
      fontSize: '0.625rem',
      lineHeight: 1.3,
      [minMd]: {
        fontSize: '1rem',
        lineHeight: 1.4,
      },
    },
    activeNormal: {
      color: `${COLORS.GREEN} !important`,
      fontSize: '0.625rem',
      lineHeight: 1.3,
      [minMd]: {
        fontSize: '1rem',
        lineHeight: 1.4,
      },
    },
    stepLabelLast: {
      color: COLORS.WHITE,
      fontWeight: 500,
      fontSize: '0.625rem',
      lineHeight: 1.3,
      [minMd]: {
        fontSize: '1rem',
        lineHeight: 1.4,
      },
    },
    activeLast: {
      color: `${COLORS.WHITE} !important`,
      fontSize: '0.625rem',
      lineHeight: 1.3,
      [minMd]: {
        fontSize: '1rem',
        lineHeight: 1.4,
      },
    },
    completedNormal: {
      color: `${COLORS.GREY_DARK} !important`,
      fontWeight: 500,
      fontSize: '0.625rem',
      lineHeight: 1.3,
      [minMd]: {
        fontSize: '1rem',
        lineHeight: 1.4,
      },
    },
    completedLast: {
      color: `${COLORS.WHITE} !important`,
      fontWeight: 500,
      fontSize: '0.625rem',
      lineHeight: 1.3,
      [minMd]: {
        fontSize: '1rem',
        lineHeight: 1.4,
      },
    },
  };
};

export default styles;
